import $ from 'jquery';

export default function() {
  /**
   *  cmsIconFix()
   *  Strips out CMS auto generated non-breaking
   *  space on icons (no external library required).
   */
  $('.glyphicon, .icon, .ns-i').each(function() {
    var elem = $(this);
    elem.html(elem.html().replace(/&nbsp;/g, ''));
  });
}



// WEBPACK FOOTER //
// ./src/webpack/components/cms-icon-fix.js